import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { SERVER, SERVER_TYPE } from "@/utils/constant";

const DebuggerTool = () => {
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const router = useRouter();   

  useEffect(() => {
    console.log("process.env.server",process.env.SERVER);
    
    if (process.env.SERVER !== SERVER_TYPE.PRODUCTION) return;
    const checkDevTools = () => {
      const start = performance.now();
      debugger; // Force debugger to trigger
      const end = performance.now();

      if (end - start > 100) {
        console.log("DevTools is open!");
        router.reload(); // Reload page if DevTools opens
      }
    };

    const interval = setInterval(checkDevTools, 1000);

    return () => clearInterval(interval);
  }, []);

  return null;
};

export default DebuggerTool;

